import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navLinks, supportEmail } from '../data/site';
export function Nav() {
  const [open, setOpen] = useState(false);
  return <header className="relative z-20 border-b border-line" data-id="element-147" data-mp="16y7rzrc5gwlj">
      <nav aria-label="Primary" className="mx-auto flex h-[76px] w-full max-w-[1440px] items-center justify-between px-6 lg:px-16" data-id="element-148" data-mp="1b0ck2lmy9l62">
        <a href="#top" aria-label="Ziaxen home" data-id="element-149" data-mp="1fzfc95htzwwm">
          <Logo data-id="element-150" data-mp="1ky8pcwt7hlw9" />
        </a>

        <ul className="hidden items-center gap-9 lg:flex" data-id="element-151" data-mp="1kxh5gj8z1clt">
          {navLinks.map(link => <li key={link.label} data-id="element-152" data-mp="1pqtgfqkq9kw3">
              <a href={link.href} className="text-sm font-medium text-muted transition-colors duration-150 ease-out hover:text-heading" data-id="element-153" data-mp="1prutu1p7ujgz">
                {link.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden items-center gap-4 md:flex" data-id="element-154" data-mp="23pt5gzc5k1ss">
          <a href="#compliance" className="rounded-lg px-2 py-2 text-sm font-medium text-body transition-colors duration-150 ease-out hover:text-accent-ink" data-id="element-155" data-mp="1y6ggub4y7kzw">
            Sign in
          </a>
          <a href={`mailto:${supportEmail}?subject=Ziaxen%20demo%20request`} className="rounded-lg border border-accent bg-accent px-[18px] py-[9px] text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-accent-hover hover:bg-accent-hover" data-id="element-156" data-mp="1p61s11srznrn">
            Request a demo
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-lg border border-line p-2 text-heading transition-colors duration-150 ease-out hover:border-accent md:hidden" data-id="element-157" data-mp="283uww9mym7ro">
          {open ? <XIcon className="h-5 w-5" data-id="element-158" data-mp="2vsnsu63l0fma" /> : <MenuIcon className="h-5 w-5" data-id="element-159" data-mp="2vrm7n8suqcqu" />}
        </button>
      </nav>

      {open && <div className="border-t border-line bg-panel px-6 py-4 md:hidden" data-id="element-160" data-mp="twyj1soynx0a">
          <ul className="flex flex-col gap-3" data-id="element-161" data-mp="xwp7vquxg326">
            {navLinks.map(link => <li key={link.label} data-id="element-162" data-mp="k7554l1cj5sv">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-1 text-sm font-medium text-muted transition-colors duration-150 ease-out hover:text-heading" data-id="element-163" data-mp="k63m9ue39f0l">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href={`mailto:${supportEmail}?subject=Ziaxen%20demo%20request`} onClick={() => setOpen(false)} className="mt-4 block rounded-lg border border-accent bg-accent px-4 py-2.5 text-center text-sm font-semibold text-white" data-id="element-164" data-mp="180ytk16vq4w">
            Request a demo
          </a>
        </div>}
    </header>;
}